import * as Mtds from '@mattilsynet/design/react'
import { renderMarkdown } from '../../utils/markdownUtils'

interface MarkdownContentProps {
  content: string
}

export const MarkdownContent = ({ content }: MarkdownContentProps) => (
  <Mtds.Prose dangerouslySetInnerHTML={{ __html: renderMarkdown(content) }} />
)
